module.exports = {
          srcSet: __webpack_public_path__ + "96eabf9418c5db3945e549ce0e0cb54f-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "96eabf9418c5db3945e549ce0e0cb54f-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "96eabf9418c5db3945e549ce0e0cb54f-801.png",
          toString:function(){return __webpack_public_path__ + "96eabf9418c5db3945e549ce0e0cb54f-801.png"},
          
          width: 801,
          height: 566
        }